import { defineRoutes } from '#utils';

export const routes = defineRoutes({
  resources: {
    find: '/resources',
  },
});
